/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CourseVideoEditQueryVariables = {
    id: string;
};
export type CourseVideoEditQueryResponse = {
    readonly courseVideoById: {
        readonly id: string;
        readonly name: string;
        readonly description: string | null;
    } | null;
};
export type CourseVideoEditQuery = {
    readonly response: CourseVideoEditQueryResponse;
    readonly variables: CourseVideoEditQueryVariables;
};



/*
query CourseVideoEditQuery(
  $id: ID!
) {
  courseVideoById(id: $id) {
    id
    name
    description
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CourseVideo",
    "kind": "LinkedField",
    "name": "courseVideoById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CourseVideoEditQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CourseVideoEditQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec095164545559ff57599195cc9a0c7a",
    "id": null,
    "metadata": {},
    "name": "CourseVideoEditQuery",
    "operationKind": "query",
    "text": "query CourseVideoEditQuery(\n  $id: ID!\n) {\n  courseVideoById(id: $id) {\n    id\n    name\n    description\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd62188961bcf513394d7a26eea449b5f';
export default node;
